// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1PZJj","filesListContainer":"PosDisputesFiles_filesListContainer__1GGwr","filesButton":"PosDisputesFiles_filesButton__37Ecd"};